module.exports = __webpack_public_path__ + "media/images/onboarding2-30159091.png";